import { createClient } from '@supabase/supabase-js';
import { Database } from '../types/database';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

console.log('Supabase URL:', supabaseUrl);
console.log('Supabase Key exists:', !!supabaseAnonKey);

// Validate environment variables
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables');
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

// Check for placeholder values
if (supabaseUrl === 'your_supabase_url' || supabaseAnonKey === 'your_supabase_anon_key') {
  console.error('Supabase environment variables are using placeholder values');
  throw new Error('Please replace placeholder values in your .env file with actual Supabase credentials.');
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false
  }
});

// Test the connection with better error handling
if (supabaseUrl && supabaseAnonKey && 
    supabaseUrl !== 'your_supabase_url' && 
    supabaseAnonKey !== 'your_supabase_anon_key') {
  
  // Add a timeout to the connection test
  const connectionTest = supabase
    .from('profiles')
    .select('count', { count: 'exact', head: true });

  // Create a timeout promise
  const timeout = new Promise((_, reject) => {
    setTimeout(() => reject(new Error('Connection timeout')), 10000);
  });

  Promise.race([connectionTest, timeout])
    .then(({ error, count }) => {
      if (error) {
        console.warn('Supabase connection test failed:', error.message);
        console.log('This might be due to network issues or RLS policies. The app may still work for authenticated users.');
      } else {
        console.log('Supabase connection successful. Profile count:', count);
      }
    })
    .catch((error) => {
      console.warn('Supabase connection test failed:', error.message);
      console.log('This might be due to network issues. The app may still work for authenticated users.');
    });
}

// Legacy helpers for backward compatibility
export { authService as authHelpers } from './database/auth';
export { dashboardService as dbHelpers } from './database/dashboard';